const overviews = [...document.querySelectorAll('.sj-mobile-overview')];
const mobile = matchMedia('(max-width: 749px)');
function sizeOverviews() { overviews.forEach(details => { details.open = !mobile.matches; }); }
sizeOverviews();
mobile.addEventListener('change', sizeOverviews);
document.addEventListener('click', event => {
  const link = event.target.closest('a[href^="#"]');
  if (!link) return;
  const target = document.getElementById(link.getAttribute('href').slice(1));
  const details = target?.closest('.sj-mobile-overview');
  if (details) details.open = true;
});

const productDetails = document.querySelector('.sjp-mobile-details');
if (productDetails) {
  productDetails.open = !mobile.matches;
  mobile.addEventListener('change', () => {productDetails.open = !mobile.matches;});
  document.querySelectorAll('a[href="#sjp-details"]').forEach(link=>link.addEventListener('click',()=>{productDetails.open=true;}));
}

// On mobile, let All Products shoppers reach the grid before the range overview.
const allOverview=document.querySelector('.sj-all-products .sj-mobile-overview');
if(allOverview){const originalSpot=document.createComment('range overview desktop position');allOverview.before(originalSpot);function placeRangeOverview(){const heroSection=originalSpot.parentElement?.closest('.shopify-section');const gridSection=heroSection?.nextElementSibling;if(mobile.matches&&gridSection){gridSection.after(allOverview);}else{originalSpot.after(allOverview);}}placeRangeOverview();mobile.addEventListener('change',placeRangeOverview);}
